// Copy the flights area's screens and components added while moving to the design system (src/ui).
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const flightsCopy = {
  nl: {
    "flight.results.previous": "Vorige wijn",
    "flight.results.next": "Volgende wijn",
  },
  en: {
    "flight.results.previous": "Previous wine",
    "flight.results.next": "Next wine",
  },
  de: {
    "flight.results.previous": "Vorheriger Wein",
    "flight.results.next": "Nächster Wein",
  },
  fr: {
    "flight.results.previous": "Vin précédent",
    "flight.results.next": "Vin suivant",
  },
  es: {
    "flight.results.previous": "Vino anterior",
    "flight.results.next": "Vino siguiente",
  },
  it: {
    "flight.results.previous": "Vino precedente",
    "flight.results.next": "Vino successivo",
  },
  pt: {
    "flight.results.previous": "Vinho anterior",
    "flight.results.next": "Vinho seguinte",
  },
} as const;
